import { FileManagementProvider } from 'global/cnr/contexts/FileManagementContext'
import ItemStorageProvider from 'global/cnr/contexts/ItemStorageContext'
import { useFileManagement } from 'global/cnr/contexts/useHelpers/useFileManagement'
import { openExternal } from 'global/viewSettings/helpers/settingsLinks'
import SidebarWrapper from 'global/wrappers/SidebarWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { getAppConfigSettings } from 'project/appConfiguration'
import { useContext, useEffect, useMemo, useState } from 'react'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { convertHelpers } from '../../common/convert'
import { gEnums } from '../../enums/globalEnums'
import WrapperVertCols from '../../wrappers/WrapperVertCols'
import UiSaveButtons from '../buttons/UiSaveButtons'
import DropdownOptionsMenu from '../forms/elements/DropdownOptionsMenu'
import FullImage from '../imaging/FullImage'
import MenuVert from '../menus/MenuVert'
import SemFileViewer from '../sem/SemFileViewer'
import DataSidebar from '../swipers/DataSidebar'
import BulkUploader from '../uploading/BulkUploader'
import TreeViewer from './TreeViewer'
import { fbAppConfigs } from 'project/appConfigs'

const confirmationTypes = {
  moveDirectToPages: 'moveDirectToPages',
  moveToGlobal: 'moveToGlobal',
  openUrlDb: 'openUrlDb',
  renameStorageImages: 'renameStorageImages',
  testRenameStorageImages: 'testRenameStorageImages',
  updateGlobalUrls: 'updateGlobalUrls',
  updateImageThumbnails: 'updateImageThumbnails',
  updateProfileGlobalUrls: 'updateProfileGlobalUrls',

}

// FileManagement > SemFileViewer > ImagesGrid/ImageGallery (fileSelectMode) 

const FileManagement = (props) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns, handlers, fn_cls } = parentContext ?? {}
  const { app_state, eventInfo_state, currentSettings_state, storage_state, paps_state } = states
  const { pathViews } = paps_state
  const { appDataDocuments } = eventInfo_state ?? {}
  const { appStorageUrlFiles, selectedImages, selectedImagePath } = storage_state
  const { storage_handlers } = handlers

  const { app_prods } = app_state ?? {}
  const { prodStorage } = app_prods ?? {}
  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  const appConfigSettings = getAppConfigSettings()
  const { isDev_me, isLocalhost } = appConfigSettings
  const environ = isDev_me || isLocalhost ? 'Dev' : 'Prod'

  // const [appStorageUrlFiles, setAssetUrls] = useState()
  const [sidebarMode, setSidebarMode] = useState()

  const [fileOptionType, setFileOptionType] = useState(props?.fileOptionType)
  const [storageType, setStorageType] = useState(props?.storageType)
  const [viewItemType, setViewItemType] = useState()
  const [viewItemData, setViewItemData] = useState()
  const [viewItemItem, setViewItemItem] = useState()
  const [updating, setUpdating] = useState()
  const [prodUrls, setPropUrls] = useState()

  const handleFinished = () => {
    handleMode()
    setUpdating(false)
  }

  const ufm = useFileManagement({ setPropUrls, handleFinished, setUpdating })

  const fileManagmentOpts = {
    fileOptionType,
    storageType,
    viewItemType,
    viewItemData,
    viewItemItem,
    allowUpload: storageType || viewItemItem
  }

  useEffect(() => {
    let _menuItems = {}
    Object.keys(gEnums.storageTypes).forEach(k => {
      switch (k) {
        case gEnums.storageTypes.manifest:
        case gEnums.storageTypes.floormap:
          break;
        default:
          _menuItems[k] = k
      }
    })
    storage_handlers.handleSet_storageType(gEnums.storageTypes.icon)
    storage_handlers.handleSet_fileOptionType(gEnums.fileOptionTypes.global)
    setFileOptionType(gEnums.fileOptionTypes.global)
    setStorageType(gEnums.storageTypes.icon)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleMode = (adm) => setSidebarMode(adm)

  const handleShow_updateGlobalUrls = async () => {
    handleMode(confirmationTypes.updateGlobalUrls)
  }

  const handleShow_updateProfileGlobalUrls = async () => {
    handleMode(confirmationTypes.updateProfileGlobalUrls)
  }

  const handleShow_moveToGlobal = async () => {
    handleMode(confirmationTypes.moveToGlobal)
  }

  const handleShow_moveDirectToPages = async () => {
    handleMode(confirmationTypes.moveDirectToPages)
  }

  const handleShow_renameStorageImages = async () => {
    handleMode(confirmationTypes.renameStorageImages)
  }

  const handleShow_testRenameStorageImages = async () => {
    handleMode(confirmationTypes.testRenameStorageImages)
  }

  const handleShow_updateImageThumbnails = async () => {
    handleMode(confirmationTypes.updateImageThumbnails)
  }

  const handleOpen_urlDb = async () => {
    openExternal.db(pathViews, null, ['_assetUrls'])
  }

  const handleOpen_profileUrlDb = async () => {
    const _pathViews = {
      clients: pathViews.clients
    }
    openExternal.db(_pathViews, null, ['profileGallery', 'galleryItems'])
  }

  const handleOpen_storage_event = async () => {
    openExternal.db(pathViews, true)
  }

  const handleOpen_storage_client = async () => {
    const _pathViews = {
      clients: pathViews.clients
    }
    openExternal.db(_pathViews, true, ['profiles'])
  }

  const handleSelect_fileOptionType = (item) => {
    setFileOptionType(item)
    setStorageType()
    setViewItemType()
    setViewItemData()
    setViewItemItem()
    storage_handlers.handleSet_fileOptionType(item)
  }

  const handleSelect_fileType = (item) => {
    setStorageType(item._itemKey)
    storage_handlers.handleSet_storageType(item._itemKey)
  }

  const handleSelect_viewItemType = (item) => {
    setViewItemType(item._itemKey)
    const appDataDocument = appDataDocuments[item._itemKey]
    convertHelpers.createItemKeys(appDataDocument)
    setViewItemData(appDataDocument)
    setViewItemItem()
    storage_handlers.handleSet_viewItemType(item._itemKey)
  }

  const handleSelect_viewItemItem = (item) => {
    setViewItemItem(item)
    storage_handlers.handleSet_viewItemItem(item)
  }

  const menuItems_select = useMemo(() => {
    return _.sortBy(gEnums.fileOptionTypes)
  }, [])

  const menuItems_storageTypes = () => {
    const sts = fileOptionType === gEnums.fileOptionTypes.global ? _.sortBy(gEnums.storageTypes_global) : _.sortBy(gEnums.storageType_page)
    const mis = _.map(sts, (st) => {
      let _st = st;
      let _count = 0;
      if (appStorageUrlFiles) {
        switch (st) {
          case gEnums.storageTypes.manifest:
            _st = 'manifests'
            _count = _.size(appStorageUrlFiles[_st]);
            break;
          case gEnums.storageTypes.pdf:
            _st = '_page_pdf'
            _count = _.size(appStorageUrlFiles[_st]?.[viewItemType]?.[viewItemItem?._itemKey])
            break;
          default:
            _count = _.size(appStorageUrlFiles[_st]);
          // nothing
        }
      }
      if (appStorageUrlFiles && appStorageUrlFiles[_st]) {
        return { _itemKey: st, name: _st, _count }
      } else {
        return { _itemKey: st, name: _st }
      }
    })
    return mis
  }


  const menuItems_viewItems = useMemo(() => {
    const { pages } = appStorageUrlFiles ?? {}
    const sts = _.sortBy(_.keys(aps_viewItems))
    const mis = _.map(sts, (st) => {
      let _st = st;
      let _count = 0;
      if (pages) {
        _count = _.size(pages[_st]);
      }
      if (pages && pages[_st]) {
        return { _itemKey: st, name: _st, _count }
      } else {
        return { _itemKey: st, name: _st, _count }
      }
    })
    return mis
  }, [])

  const menuItems_viewItem = useMemo(() => {
    const sts = _.orderBy(viewItemData, ['lastName', 'name'])
    const { pages } = appStorageUrlFiles ?? {}
    const zzz = pages?.[viewItemType]
    const mis = _.map(sts, (st) => {
      let _st = st;
      const { _itemKey, startDate } = st
      const name = convertHelpers.getItemName(st)
      let _count = 0;
      if (zzz) {
        _count = _.size(zzz[_itemKey]);
      }
      if (zzz?.[_st]) {
        return { _itemKey, name, _count, startDate }
      } else {
        return { _itemKey, name, _count, startDate }
      }
    })
    console.log('mis', mis)
    return mis
  }, [viewItemType])

  /**
 * 
 * @returns list of fileOptionTypes
 */
  const menu_vert_select = () => <MenuVert
    menuItems={menuItems_select}
    oc={handleSelect_fileOptionType}
    activeMenuItem={fileOptionType}
    header={'File Option Type'}
  />

  /**
   * 
   * @returns list of assetUrl keys
   */
  const menu_vert_storageTypes = () => <MenuVert
    menuItems={menuItems_storageTypes()}
    oc={handleSelect_fileType}
    activeMenuItem={storageType}
    header={'Storage Option Type'}
    showCount={true}
  />

  const menu_vert_viewItems = () => <MenuVert
    menuItems={menuItems_viewItems}
    oc={handleSelect_viewItemType}
    activeMenuItem={viewItemType}
    header={'Page Items'}
    showCount={true}
  />

  const menu_vert_viewItem = () => <MenuVert
    menuItems={menuItems_viewItem}
    oc={handleSelect_viewItemItem}
    activeMenuItem={viewItemItem}
    header={'Page Item'}
    showCount={true}
  />

  const semFileViewer = () => <SemFileViewer
    allowUpload={true}
    formProps={{}}
    storageType={storageType}
    fileMode={gEnums.fileModes.view}
    fileManagmentOpts={fileManagmentOpts}
    fromFileManagement={true}
  />

  const menu_image = (imageProps) => <FullImage
    menuItems={menuItems_viewItem}
    imageProps={imageProps}
  />

  const wrapper_image = (imageProps) => <Wrapper
    // header={<div style={{ display: 'flex', justifyContent: 'space-between' }}><div>{'Selected File'}</div><Icon name='delete'></Icon></div>}
    header={'Selected File'}
    content={menu_image(imageProps)}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const prodViewer = () => <Wrapper
    header={'Prod Viewer'}
    content={<TreeViewer data={prodUrls} />}
  />

  /**
 * 
 * @returns the content for global files
 */
  const content_clientProfiles = () => {
    let cn = 'file-management-profiles'
    let imageProps = { selectedImagePath }
    if (!_.isEmpty(selectedImages)) {
      imageProps = {
        fileName: _.keys(selectedImages)[0],
        fileOptionType: fileOptionType,
        storageType: storageType,
        selectedImagePath,
      }
      // cn += ' sel' 
    }
    return <WrapperVertCols split={props?.split} mvc={prodUrls ? '3' : cn}>
      {menu_vert_select()}
      <ItemStorageProvider showItemImage={true} viewItemKey={'attendees'}>
        <BulkUploader viewItemKey={'attendees'} storageLocationType={gEnums.storageLocationTypes.clientProfiles} />
      </ItemStorageProvider>
    </WrapperVertCols >
  }

  /**
   * 
   * @returns the content for global files
   */
  const content_global = () => {
    let cn = 'file-management'
    let imageProps = { selectedImagePath }
    if (!_.isEmpty(selectedImages)) {
      imageProps = {
        fileName: _.keys(selectedImages)[0],
        fileOptionType: fileOptionType,
        storageType: storageType,
        selectedImagePath,
      }
      // cn += ' sel' 
    }
    return <WrapperVertCols split={props?.split} mvc={prodUrls ? '3' : cn}>
      {menu_vert_select()}
      {menu_vert_storageTypes()}
      {semFileViewer()}
    </WrapperVertCols >
  }

  /**
   * 
   * @returns the content for page files
   */
  const content_pages = () => {
    let cn = 'file-management-page'
    let imageProps = {}
    if (!_.isEmpty(selectedImages)) {
      imageProps = {
        fileName: _.keys(selectedImages)[0],
        fileOptionType: fileOptionType,
        storageType: storageType,
        selectedImagePath,
      }
      // cn += ' sel'
    }
    return <WrapperVertCols mvc={prodUrls ? '3' : cn}>
      {menu_vert_select()}
      {menu_vert_viewItems()}
      {menu_vert_viewItem()}
      {semFileViewer()}
      {prodUrls && prodViewer()}
    </WrapperVertCols >
  }


  const footer_main = () => {
    const btns_sa = []
    const btns_ia = []
    const btns_e = []

    btns_sa.push({ oc: handleShow_moveDirectToPages, caption: _.startCase(confirmationTypes.moveDirectToPages), icon: 'arrow right', fl: true })
    btns_sa.push({ oc: handleShow_moveToGlobal, caption: _.startCase(confirmationTypes.moveToGlobal), icon: 'arrow right', fl: true })
    btns_sa.push({ oc: handleShow_renameStorageImages, caption: _.startCase(confirmationTypes.renameStorageImages), icon: 'arrow right', fl: true })
    btns_sa.push({ oc: handleShow_testRenameStorageImages, caption: _.startCase(confirmationTypes.testRenameStorageImages), icon: 'arrow right', fl: true })
    btns_sa.push({ oc: handleShow_updateImageThumbnails, caption: _.startCase(confirmationTypes.updateImageThumbnails), icon: 'arrow right', fl: true })

    btns_ia.push({ oc: handleShow_updateProfileGlobalUrls, caption: _.startCase(confirmationTypes.updateProfileGlobalUrls), icon: 'arrow right', fl: true })
    btns_ia.push({ oc: handleShow_updateGlobalUrls, caption: _.startCase(confirmationTypes.updateGlobalUrls), icon: 'arrow right', fl: true })
    // btns_ia.push({ oc: ufm.handleGet_prodStorage, caption: 'Get Prod Storage', icon: 'arrow right', color: 'blue', fl: true })

    btns_e.push({ oc: handleOpen_urlDb, caption: 'Open URL DB', icon: 'arrow right', color: 'blue', fl: true })
    btns_e.push({ oc: handleOpen_profileUrlDb, caption: 'Open Profile URL DB', icon: 'arrow right', color: 'blue', fl: true })
    btns_e.push({ oc: handleOpen_storage_event, caption: 'Open Event Storage', icon: 'arrow right', color: 'blue', fl: true })
    btns_e.push({ oc: handleOpen_storage_client, caption: 'Open Client Storage', icon: 'arrow right', color: 'blue', fl: true })

    const ddom_sa = <DropdownOptionsMenu
      menuButtons={btns_sa}
      caption={'Storage Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />

    const ddom_ia = <DropdownOptionsMenu
      menuButtons={btns_ia}
      caption={'URL Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />

    const ddom_e = <DropdownOptionsMenu
      menuButtons={btns_e}
      caption={'Open Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />

    return [ddom_sa, ddom_ia, ddom_e]
  }

  const footer_confirm = () => {
    const btns = []
    switch (sidebarMode) {
      case confirmationTypes.testRenameStorageImages:
        btns.push({ oc: ufm.handleUpdate_testRenameStorageImages, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.renameStorageImages:
        btns.push({ oc: ufm.handleUpdate_renameStorageImages, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.updateProfileGlobalUrls:
        btns.push({ oc: ufm.handleUpdate_profileGlobalUrls, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.updateImageThumbnails:
        btns.push({ oc: ufm.handleUpdate_updateImageThumbnails, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.moveToGlobal:
        btns.push({ oc: ufm.handleUpdate_moveToGlobal, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.updateGlobalUrls:
        btns.push({ oc: ufm.handleUpdate_globalUrls, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
      case confirmationTypes.moveDirectToPages:
        btns.push({ oc: ufm.handleUpdate_moveDirectToPages, caption: _.startCase(sidebarMode), icon: 'save', color: 'green' })
        break;
    }

    return <UiSaveButtons others={btns} />
  }

  const content = () => {
    switch (fileOptionType) {
      case gEnums.fileOptionTypes.clientProfile:
        return content_clientProfiles()
      case gEnums.fileOptionTypes.global:
        return content_global()
      case gEnums.fileOptionTypes.pages:
        return content_pages()
    }
  }
  const wrapper = () => <FileManagementProvider fileManagmentOpts={fileManagmentOpts}>
    <Wrapper
      content={content()}
      footer={footer_main()}
    />
  </FileManagementProvider>

  const content_right = () => {
    let caption = 'caption';
    switch (sidebarMode) {
      case confirmationTypes.renameStorageImages:
      case confirmationTypes.testRenameStorageImages:
      case confirmationTypes.updateProfileGlobalUrls:
      case confirmationTypes.updateImageThumbnails:
        const appConfigSettings = getAppConfigSettings()
        const { isDev_me, isLocalhost } = appConfigSettings
        const projectIds = {
          source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
        }
        caption = `${_.startCase(sidebarMode)} (${projectIds.source})`
        break;
      case confirmationTypes.moveToGlobal:
        caption = _.startCase(sidebarMode)
        break;
      case confirmationTypes.updateGlobalUrls:
        caption = _.startCase(sidebarMode)
        break;
      case confirmationTypes.moveDirectToPages:
        caption = _.startCase(sidebarMode)
        break;
    }
    return <Wrapper
      header={`Confirmation: ${caption}`}
      content={caption + '?'}
      footer={footer_confirm()}
      wrapperType={wrapperTypes.padded}
      updating={updating}
    />
  }

  const sidebar_right = (visible) => <DataSidebar direction={'right'} visible={visible} content={visible && content_right()} onHide={setSidebarMode} />

  const sidebar = () => <SidebarWrapper
    sidebarContent={wrapper()}
    sidebarRight={sidebar_right(sidebarMode)}
    sidebarOn={sidebarMode}
  />

  return sidebar()

}

export default FileManagement
